import { PendingItemDto, UserDto } from '@act/shared/data-transfer-objects';

export interface PendingItemWithMember extends PendingItemDto {
  member: UserDto;
}

export const convertToPendingItemWithMember = (
  pendingItem: PendingItemDto,
  memberMap: { [key: string]: UserDto }
): PendingItemWithMember => {
  return { ...pendingItem, member: memberMap[pendingItem.memberId] };
};
